import React from "react";
import "./custompaper.scss";
import { Paper } from "@mui/material";

const CustomPaper = (props) => {
  return (
    <Paper
      {...props}
      className={props.className + " custom-paper-outline"}
      elevation={3}
    ></Paper>
  );
};

export default CustomPaper;
